import { CompanyPagination } from './../model/company_pagination';
import { FetchCompanyRepository } from './../../data/repository/fetch_company_repository';
import { Pagination } from "@/core/domain/model/pagination";
import { DataOptions } from "vuetify";
import { en, CompanyFilters } from '../model/company';

type CompanyOptions = DataOptions & CompanyFilters;

export interface FetchCompanyUseCase {
    (pagination: CompanyOptions, search: string): Promise<CompanyPagination>
}

const fetchCompanyUseCase = (repository: FetchCompanyRepository): FetchCompanyUseCase => async (pagination: CompanyOptions, search: string) => {
    try {
        const payload: Pagination & CompanyFilters = {
            sort: pagination.sortBy.map((s: string) => en[s]).join(','),
            descending: pagination.sortDesc.join(','),
            page: pagination.page,
            itemsPerPage: pagination.itemsPerPage,
            search: search,
            withInactive: pagination.withInactive,
        }
        return await repository(payload);
    } catch (error) {
        throw error
    }
}

export default fetchCompanyUseCase;
